<template lang="pug">
  li.v-list__item
    slot
</template>

<script>
export default {
  name: 'VListItem'
}
</script>
